import { AddressValidation } from '../types';

const initAddressValid: AddressValidation = {
  Title: { isErr: false, errMsg: '', canNotSave: true },
  TypeId: { isErr: false, errMsg: '', canNotSave: true },
  Line1: { isErr: false, errMsg: '', canNotSave: true },
  City: { isErr: false, errMsg: '', canNotSave: false },
  Province: { isErr: false, errMsg: '', canNotSave: false },
  PostalCode: { isErr: false, errMsg: '', canNotSave: true },
  Country: { isErr: false, errMsg: '', canNotSave: false },
  PatrolType: { isErr: false, errMsg: '', canNotSave: true },
};

export const loadedAddressValid: AddressValidation = {
  Title: { isErr: false, errMsg: '', canNotSave: false },
  TypeId: { isErr: false, errMsg: '', canNotSave: false },
  Line1: { isErr: false, errMsg: '', canNotSave: false },
  City: { isErr: false, errMsg: '', canNotSave: false },
  Province: { isErr: false, errMsg: '', canNotSave: false },
  PostalCode: { isErr: false, errMsg: '', canNotSave: false },
  Country: { isErr: false, errMsg: '', canNotSave: false },
  PatrolType: { isErr: false, errMsg: '', canNotSave: false },
};

export default initAddressValid;
